<template>
  <div class="app">
    <div class="Edit-job">
      <div class="job-date">
        <div class="job-date-title import">日期：</div>
        <el-date-picker size="small" v-model="post.startDate" type="month" popper-class="customePopper"
          placeholder="请选择">
        </el-date-picker>
        <span style="margin: 0 10px;">至</span>
        <el-date-picker size="small" v-model="post.endDate" type="month" class="pickerPlace"
          popper-class="customePopper" :picker-options="pickerOptions" :placeholder="post.endDate ? '至今' : '请选择'">
        </el-date-picker>
      </div>
      <div class="job-info">
        <div class="info-Company-Name">
          <div class="Company-Name-title import">公司：</div>
          <el-input size="small" placeholder="请输入公司名" v-model="post.companyName" clearable>
          </el-input>
        </div>
        <div class="info-Position-Name">
          <div class="Position-Name-title import">职位：</div>
          <el-input size="small" placeholder="请输入职位名" v-model="post.position" clearable>
          </el-input>
        </div>
      </div>
      <div class="Company-Relation">
        <div class="Relation-title">工作关系：</div>
        <div class="Relation-bottom">
          <el-input size="small" placeholder="工作部门" v-model="post2.department" clearable>
          </el-input>
          <el-input size="small" placeholder="汇报对象" v-model="post2.report" clearable>
          </el-input>
          <el-input size="small" placeholder="管理人数" v-model="post2.people" clearable>
          </el-input>
        </div>
      </div>
      <div class="Job-Respon">
        <div class="Respon-title import">工作职责：</div>
        <el-input type="textarea" resize="none" :autosize="{ minRows: 4 }" placeholder="具体的工作内容" v-model="post.respon"
          maxlength="3000" show-word-limit>
        </el-input>
      </div>
      <div class="Job-Performance">
        <div class="Performance-title">工作业绩：</div>
        <el-input type="textarea" resize="none" :autosize="{ minRows: 3 }" placeholder="具体的工作业绩"
          v-model="post2.Performance" maxlength="2000" show-word-limit>
        </el-input>
      </div>
      <div class="Reason-Leave" v-if="post.endDate == '9999.0' || post.endDate == '至今'">
        <div class="Leave-title">求职动机：</div>
        <el-input placeholder="真实的求职动机" v-model="post2.Leave" clearable>
        </el-input>
      </div>
      <div class="Reason-Leave" v-else>
        <div class="Leave-title">离职原因：</div>
        <el-input size="small" placeholder="真实的离职原因" v-model="post2.Leave" clearable>
        </el-input>
      </div>
      <div class="info-btn">
        <el-button size="medium" @click="cancel">取消</el-button>
        <el-button type="primary" size="medium" @click="save">确认</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { updateworkInfo, AddWorkInfo } from '@/request/api'

export default {
  props: {
    val: {
      type: Array,
      default: () => ({})
    },
    name: {
      type: String,
      default: ''
    },
    Index: {
      type: Number,
      default: 0
    }
  },
  created() {
    this.post.username = JSON.parse(sessionStorage.getItem('LoginInfo')).username
    if (this.name !== 'EditWork') {
      return
    }
    this.post2.workID = this.val[this.Index].workID
    this.post2.comID = this.val[this.Index].companyID
    this.post.startDate = this.val[this.Index].startTime
    this.post.endDate = this.val[this.Index].endTime === '9999.0' ? '至今' : this.val[this.Index].endTime
    this.post.companyName = this.val[this.Index].companyName == '9999' ? '' : this.val[this.Index].companyName.replace(/<span class='HPRK'>|<\/span>/g, '');
    this.post.position = this.val[this.Index].jobName == '9999' ? '' : this.val[this.Index].jobName.replace(/<span class='HPRK'>|<\/span>/g, '');
    this.post2.department = this.val[this.Index].department == '9999' ? '' : this.val[this.Index].department
    this.post2.report = this.val[this.Index].report == '9999' ? '' : this.val[this.Index].report
    this.post2.people = this.val[this.Index].people == '9999' ? '' : this.val[this.Index].people
    this.post.respon = this.val[this.Index].workContent == '9999' ? '' : this.val[this.Index].workContent
    this.post.respon = this.post.respon == undefined ? '' : this.post.respon.replace(/<br\/>/g, '\n')
    this.post.respon = this.post.respon.replace(/<span class='HPRK'>|<\/span>/g, '');
    this.post2.Performance = this.val[this.Index].workAchievement == '9999' ? '' : this.val[this.Index].workAchievement
    this.post2.Performance = this.post2.Performance == undefined ? '' : this.post2.Performance.replace(/<br\/>/g, '\n')
    this.post2.Performance = this.post2.Performance.replace(/<span class='HPRK'>|<\/span>/g, '');

    this.post2.Leave = this.val[this.Index].dimission == '9999' ? '' : this.val[this.Index].dimission
  },
  data() {
    return {
      post: {
        resumeID: '',
        startDate: null,
        endDate: null,
        companyName: '', //公司名
        position: '', //职位
        respon: '', //工作职责
        username: ''
      },
      post2: {
        comID: '',
        workID: '',
        profile: '', //公司介绍
        department: '', // 工作部门
        report: '', //汇报对象
        people: '', //管理人数
        Performance: '', //工作业绩
        Leave: '' //离职原因
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '至今',
            onClick: picker => {
              picker.$emit('pick', '至今')
            }
          }
        ]
      }
    }
  },
  watch: {
    value2(newVal, oldVal) {
      if (newVal === '至今') {
        this.type = '至今'
      }
      var val = new Date(newVal)
      let year = val.getFullYear()
      let month = val.getMonth() + 1
    },
    deep: true
  },
  methods: {
    cancel() {
      this.$emit('workInfoShow', false)
    },
    textBetween(str, left_key, right_key) {
      var g_left = str.indexOf(left_key)
      if (g_left != -1) {
        g_left = g_left + left_key.length
        var g_right = str.indexOf(right_key, g_left)
      }
      if (g_right != -1) {
        return str.substr(g_left, g_right - g_left)
      }
    },
    isPostDataEmpty(post) {
      // 检查 post 对象中的每个属性是否为空
      for (let key in post) {
        if (post.hasOwnProperty(key) && post[key] === '') {
          // 如果发现空属性，返回 true
          return true
        }
      }
      // 如果所有属性都不为空，返回 false
      return false
    },
    async save() {
      const date = new Date(this.post.startDate)
      const year = date.getFullYear()
      const month = date.getMonth() + 1 // getMonth() 返回 0-11，表示 1-12 月
      this.post.startDate = `${year}.${month.toString().padStart(2, '0')}`

      if (this.post.endDate === '至今') {
        this.post.endDate = '9999.0'
      } else {
        const date2 = new Date(this.post.endDate)
        const year2 = date2.getFullYear()
        const month2 = date2.getMonth() + 1 // getMonth() 返回 0-11，表示 1-12 月
        this.post.endDate = `${year2}.${month2.toString().padStart(2, '0')}`
      }
      if (this.name !== 'EditWork') {
        this.post.resumeID = this.textBetween(this.$route.fullPath, 'resumeID=', '&timestamp')
        if (this.isPostDataEmpty(this.post)) {
          this.$message({
            message: '请完善数据后再提交！',
            type: 'warning'
          })
          return
        }
        const post3 = { ...this.post, ...this.post2 }
        const { data: res } = await AddWorkInfo(post3)
        this.$emit('workInfoShow', true)
      } else {
        this.post.resumeID = this.textBetween(this.$route.fullPath, 'resumeID=', '&timestamp')
        if (this.isPostDataEmpty(this.post)) {
          this.$message({
            message: '请完善数据后再提交！',
            type: 'warning'
          })
          return
        }
        const post3 = { ...this.post, ...this.post2 }
        const { data: res } = await updateworkInfo(post3)
        this.$emit('workInfoShow', true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// 其他浏览器兼容性自测
.job-date .el-input__inner::-webkit-input-placeholder {
  color: #000;
}

.customePopper .el-picker-panel [slot='sidebar']+.el-picker-panel__body,
.customePopper .el-picker-panel__sidebar+.el-picker-panel__body {
  margin-left: 0;
  margin-bottom: 20px;
}

.customePopper .el-picker-panel [slot='sidebar'],
.customePopper .el-picker-panel__sidebar {
  top: unset;
  left: 0;
  right: 0;
  border-right: none;
  width: unset;
  padding: 0;

  .el-picker-panel__shortcut {
    text-align: center;
    padding: 0;
    line-height: 50px;
  }
}

.customePopper.el-date-picker.has-sidebar {
  width: unset;
}

.Edit-job {
  background: #f4f5fb;
  padding: 20px;
  border: 1px solid #eee;
  box-sizing: border-box;
}

.job-date {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .el-input__inner,
  .el-date-picker,
  .el-date-editor {
    width: 120px;
    height: 35px;
    line-height: 35px;
  }

  .el-input__icon {
    line-height: 35px;
  }
}

.import::before {
  content: '* ';
  color: red;
  font-size: 18px;
}

.job-info {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .info-Company-Name {
    display: flex;
    align-items: center;
    white-space: nowrap;
    margin-right: 40px;
  }

  .info-Position-Name {
    display: flex;
    align-items: center;
    white-space: nowrap;
  }
}

.el-input__inner {
  height: 35px;
}

.Company-Profile {
  white-space: nowrap;
  margin-bottom: 20px;

  .Profile-title {
    margin-bottom: 10px;
  }
}

.Company-Relation {
  white-space: nowrap;
  margin-bottom: 20px;

  .Relation-title {
    margin-bottom: 10px;
  }

  .Relation-bottom {
    display: flex;

    .el-input__inner,
    .el-input {
      width: 140px;
      margin-right: 15px;
    }
  }
}

.Job-Respon {
  white-space: nowrap;
  margin-bottom: 20px;

  .Respon-title {
    margin-bottom: 10px;
  }
}

.Job-Performance {
  white-space: nowrap;
  margin-bottom: 20px;

  .Performance-title {
    margin-bottom: 10px;
  }
}

.Reason-Leave {
  white-space: nowrap;
  margin-bottom: 20px;

  .Leave-title {
    margin-bottom: 10px;
  }
}

.info-btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>